import __request__ from "routing/request";
export function listNodes(sort = "name", page = 1, per_page = 50, query, order = "asc", requestOptions) {
  return __request__("GET", "/system/cluster/mongodb", null, { "page": page, "per_page": per_page, "query": query, "sort": sort, "order": order }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function profilingStatus(requestOptions) {
  return __request__("GET", "/system/cluster/mongodb/profiling/status", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function changeProfiling(level, requestOptions) {
  return __request__("PUT", `/system/cluster/mongodb/profiling/${level}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
